<template>
  <div class="template-item-wrapper" :class="wrapperClassArray">
    <label class="template-item-label" :class="labelClassArray" :style="labelStyleObject">
      <slot name="label">{{ label }}{{ colonText }}</slot>
    </label>
    <slot name="contentWrapper">
      <span
        class="template-item-content"
        :class="contentClassArray"
        :style="contentStyleObject"
      >
        <slot />
      </span>
    </slot>
  </div>
</template>
<script>
const splitClasses = (classes) => {
  if (!classes) {
    return [];
  }
  return classes.split(/ +/gim).filter((it) => it);
};
const splitStyles = (styles) => {
  if (!styles) {
    return {};
  }
  const entities = styles.split(";");
  const obj = {};
  entities.forEach((entity) => {
    if (!entity) {
      return;
    }
    const array = entity
      .split(":")
      .map((it) => it.trim())
      .filter((it) => it);
    if (array.length === 2) {
      obj[array[0]] = array[1];
    }
  });
  return obj;
};
export default {
  name: "template-item",
  props: {
    label: {
      type: String,
    },
    colon: {
      type: Boolean,
      default: true,
    },
    labelClasses: {
      type: String,
    },
    wrapperClasses: {
      type: String,
    },
    contentClasses: {
      type: String,
    },
    contentStyles: {
      type: String,
    },
    labelStyles: {
      type: String,
    },
    layout: {
      type: String,
      default: "block",
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ["flex", "block"].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    colonText() {
      return this.colon ? ":" : null;
    },
    labelClassArray() {
      const { labelClasses, layout } = this.$props;
      const array = splitClasses(labelClasses);
      array.push("template-item-label");
      if (layout === "flex") {
        array.push("flex-auto");
      }
      return array;
    },
    wrapperClassArray() {
      const { wrapperClasses, layout } = this.$props;
      const array = splitClasses(wrapperClasses);
      array.push("template-item-wrapper");
      if (layout === "flex") {
        array.push("flex", "flex-row");
      }
      return array;
    },
    contentClassArray() {
      const { contentClasses, layout } = this.$props;
      const array = splitClasses(contentClasses);
      array.push("template-item-content");
      if (layout === "flex") {
        array.push("flex-fill");
      }
      return array;
    },
    contentStyleObject() {
      const { contentStyles } = this.$props;
      return splitStyles(contentStyles);
    },
    labelStyleObject() {
      const { labelStyles } = this.$props;
      return splitStyles(labelStyles);
    },
  },
};
</script>
<style scoped>
.template-item-label {
  vertical-align: top;
  width: 100px;
  display: inline-block;
}
.template-item-wrapper {
  padding: 5px 0;
}
.template-item-content {
  display: inline-block;
}
.flex.template-item-content {
  display: flex;
}
</style>
